import { CardSize } from '@aviv-classified-card/card/full';
export const filterSize = (size) => CardSize[size];
export const createEnrichedData = ({ suggestedClassifiedsIds = [], visibilityEffects = {}, }) => {
    const uniqIds = new Set(suggestedClassifiedsIds.concat(Object.keys(visibilityEffects)));
    return Array.from(uniqIds).reduce((acc, id) => ({
        ...acc,
        [id]: {
            size: filterSize(visibilityEffects[id]?.size),
            isSuggestion: suggestedClassifiedsIds.includes(id),
        },
    }), {});
};
